import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Switch from 'app/scripts/components/common/inputs/customs/switch';
import { autobind } from 'core-decorators';
import SelectInput from 'app/scripts/components/common/inputs/select-input';
import { withEditSpot } from '../../../spots/hoc/withEditSpot';

var GIF_LEVEL_KEYS = {
  Y: { value: 'y', text: 'Y', description: 'Illustrated content only' },
  G: { value: 'g', text: 'G', description: 'All GIFs are suitable for all ages' },
  PG: { value: 'pg', text: 'PG', description: 'Some GIFs may not be suitable for children' },
  PG_13: {
    value: 'pg_13',
    text: 'PG-13',
    description: "Some GIF's may be inappropriate for children under 13"
  },
  R: { value: 'r', text: 'R', description: 'Some GIFs may contain some adult material' }
};

function getGifAnimationLevel(value) {
  value = value?.toLowerCase();
  var gifLevel = null;

  switch (value) {
    case 'y':
      gifLevel = GIF_LEVEL_KEYS.Y;
      break;
    case 'pg':
      gifLevel = GIF_LEVEL_KEYS.PG;
      break;
    case 'pg_13':
      gifLevel = GIF_LEVEL_KEYS.PG_13;
      break;
    case 'r':
      gifLevel = GIF_LEVEL_KEYS.R;
      break;
    case 'g':
      gifLevel = GIF_LEVEL_KEYS.G;
      break;

    default:
      gifLevel = GIF_LEVEL_KEYS.G;
  }
  return gifLevel;
}

class GifAnimation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toolTipText =
      'The main policy for comments that contain GIFs is to reject them automatically. Therefore, the option to search for GIFs in the conversation is disabled. If you wish to allow searching GIFs please update the policy under Settings > Policy > Moderation Main Policy.';
  }

  static defaultProps = {
    value: true
  };

  static propTypes = {
    gifLevel: PropTypes.string.isRequired,
    spotId: PropTypes.string.isRequired
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired
  };

  static displayName = 'GifAnimation';

  handleChange() {
    const value = this.props.gifLevel === 'none' ? 'g' : 'none';
    this.edit(value);
  }

  edit(value) {
    const giphyLevel = value !== 'none' ? value.toUpperCase() : 'none';

    this.props.editSpot(this.props.spotId, { giphy_level: giphyLevel });
  }

  @autobind
  onChange() {
    this.enabledBySpotPolicy && this.handleChange();
  }

  @autobind
  handleLevelChange(gifLevel) {
    const value = gifLevel.value;
    this.edit(value);
  }

  get enabledBySpotPolicy() {
    const { gifSpotPolicy } = this.props;
    return gifSpotPolicy !== 'block_all';
  }

  getControlsProps() {
    return this.enabledBySpotPolicy
      ? {}
      : {
          'aria-label': this.toolTipText,
          'data-balloon-pos': 'up',
          'data-balloon-length': 'large',
          className: 'toggle-controls'
        };
  }

  getComputedValue() {
    const { gifLevel } = this.props;
    return gifLevel !== 'none' && this.enabledBySpotPolicy;
  }

  renderGifLevels() {
    let { gifLevel } = this.props;
    let component = null;
    if (this.enabledBySpotPolicy && gifLevel !== 'none') {
      let gifAnimationLevel = getGifAnimationLevel(gifLevel);
      component = (
        <div className="gif-levels">
          <div className="level-text left-text">Allow GIFs with MPAA rating</div>
          <SelectInput
            size="small"
            onChange={this.handleLevelChange.bind(this)}
            options={[
              GIF_LEVEL_KEYS.Y,
              GIF_LEVEL_KEYS.G,
              GIF_LEVEL_KEYS.PG,
              GIF_LEVEL_KEYS.PG_13,
              GIF_LEVEL_KEYS.R
            ]}
            value={gifAnimationLevel}
          />
          <div className="level-text right-text">{gifAnimationLevel.description}</div>
        </div>
      );
    }

    return component;
  }

  render() {
    return (
      <div className="gif-animation">
        <Switch
          title="Insert Animated GIFs"
          description="Allow search animated GIFs and insert them in comments."
          value={this.getComputedValue()}
          onChange={this.onChange}
          controlsProps={this.getControlsProps()}
        />
        {this.renderGifLevels()}
      </div>
    );
  }
}

export default withEditSpot(GifAnimation);
